module.exports = __webpack_public_path__ + "img/8_dp.8752dff2.png";